import { render, staticRenderFns } from "./support.vue?vue&type=template&id=7561ab76"
import script from "./support.ts?vue&type=script&lang=js&external"
export * from "./support.ts?vue&type=script&lang=js&external"
import style0 from "./support.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports